var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{style:({ width: _vm.width, verticalAlign: 'top' }),attrs:{"value-key":_vm.valueKey,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"fetch-suggestions":_vm.querySearch},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }